<template>
  <div class="order-details-account">
    <!--收款账户-->
    <div class="account-item border-bottom">
      <span class="label">收款账户</span>
      <div class="value">
        <span class="account-name"
          >{{ orderDetails.bankName }} ({{
            maskBankCard(orderDetails.bankNumber)
          }})</span
        >
        <img
          class="account-right-icon"
          src="@/assets/style/oride-icon.png"
          alt=""
        />
      </div>
    </div>
    <!--默认还款账户：-->
    <div
      class="default-account-item border-bottom"
      @click="handleClickDefaultAccount"
    >
      <span class="label">默认还款账户</span>
      <div class="value">
        <span class="account-name"
          >{{ orderDetails.repaymentBankName }} ({{
            maskBankCard(orderDetails.repaymentBankNumber)
          }})</span
        >
        <img class="right-icon" src="@/assets/style/oride-icon.png" alt="" />
      </div>
    </div>
    <!--合同协议-->
    <div class="contract-item" @click="handleClickContract">
      <span class="label">合同协议</span>
      <img class="right-icon" src="@/assets/style/oride-icon.png" alt="" />
    </div>
    <!--选择默认银行卡-->
    <selectDefaultBankCardPopup ref="selectDefaultBankCardPopupRef" />
    <Popup
      ref="popup"
      message="请联系客服进行查看"
      confirmText="联系客服"
      cancelText="取消"
      title="温馨提示"
      @confirm="handleClickCustomerService"
      @cancel="gotoHome"
    />
  </div>
</template>

<script>
import { maskBankCard } from "@/utils/utils.js";
import selectDefaultBankCardPopup from "@/components/orderDetails/selectDefaultBankCardPopup.vue";
import Popup from "@/components/Popup/index.vue";

export default {
  name: "orderDetailsAccount",
  components: {
    selectDefaultBankCardPopup,
    Popup,
  },
  data() {
    return {
      maskBankCard,
    };
  },
  async mounted() {},
  methods: {
    //点击合同协议
    handleClickContract() {
      this.$refs.popup.showPopup();
    },
    //点击默认还款账户
    handleClickDefaultAccount() {
      this.$refs.selectDefaultBankCardPopupRef.init();
    },
    //点击联系客服
    handleClickCustomerService() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
        const nickName = this.userInfo?.username || "";
        const clientId = localStorage.getItem("phone")? `phone_${localStorage.getItem("phone")}` : "";
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=f12bce20-49ee-11f1-aea3-c5caf3f64abe&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN&nickName=${nickName}&clientId=${clientId}`,
        );
      }
    },
    //点击返回首页
    gotoHome() {
     
    },
  },
  computed: {
    orderDetails() {
      return this.$store.getters.orderDetails;
    },
  },
};
</script>

<style scoped lang="scss">
.order-details-account {
  padding: 6px 16px;
  background: #fff;
  border-radius: 8px;
  margin-top: 16px;
}
.account-item,
.default-account-item,
.contract-item {
  display: flex;
  align-items: center;
  padding: 15px 0px;
  font-size: 15px;
  justify-content: space-between;
  color: #333;
  .value {
    display: flex;
    align-items: center;
  }
}
.right-icon {
  width: 18px;
  height: 18px;
  margin-top: 3px;
  margin-left: 14px;
}
.account-right-icon {
  visibility: hidden;
  width: 18px;
  height: 18px;
  margin-left: 14px;
}
</style>
